//imports
import React from "react";
import MyGroups from "./MyGroups"

class GroupsHome extends React.Component {
    render(){
        return (
            <section>
                <MyGroups
                    history = {this.props.history}
                />
            </section>
        );
    }
}

export default GroupsHome;